<template>
    <div class="aba-lote select-modal" style="heigth: 100%">
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoTelaAssProdutoLote.create &&
                        !assProdutoLoteIntegracao &&
                        permissaoTelaLote.create &&
                        !loteIntegracao
                            ? 'is-4'
                            : permissaoTelaAssProdutoLote.create &&
                              !assProdutoLoteIntegracao &&
                              (!permissaoTelaLote.create || loteIntegracao)
                            ? 'is-7'
                            : permissaoTelaLote.create &&
                              !loteIntegracao &&
                              (!permissaoTelaAssProdutoLote.create || assProdutoLoteIntegracao)
                            ? 'is-10'
                            : 'is-4',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-pesquisa-lote-empresa"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div
                    class="column is-3"
                    v-if="permissaoTelaAssProdutoLote.create && !assProdutoLoteIntegracao"
                >
                    <button class="save-btn botao-acao" type="button" @click="showModalLote">
                        {{ $t('vincular-lote') }}
                    </button>
                </div>
                <div class="column is-3" v-if="!loteIntegracao && permissaoTelaLote.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-produto-lote-new',
                                query: {
                                    tela: 'produto-lote',
                                    id: $route.params.id,
                                    dadoscadastrais: 8,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-lote') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assLotes"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricaolote'">
                            <a
                                @click="selectedLoteEdit(props.row)"
                                v-if="
                                    permissaoTelaAssProdutoLote.update && !assProdutoLoteIntegracao
                                "
                            >
                                {{ props.row[f.key] }}
                            </a>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="
                                    permissaoTelaAssProdutoLote.update && !assProdutoLoteIntegracao
                                "
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao" @close="fecharModal">
                <div class="bg">
                    <LoteModal
                        :idProduto="$route.params.id"
                        :selected="assLoteSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import AssProdutoLoteService from '@/services/vendas/produto/AssProdutoLoteService';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import LoteModal from '@/components/vendas/produto/modal/LoteModal.vue';

export default {
    components: {
        LoteModal,
        ContainerLoader,
    },
    data() {
        return {
            service: null,
            produtoService: null,
            empresaService: null,
            validation: null,
            idpedido: 0,
            lote: {},
            fields: [
                { key: 'idassprodutolote', width: null, label: 'codigo', sortable: true },
                { key: 'descricaolote', width: null, label: 'lote', sortable: true },
                { key: 'descricaoempresa', width: null, label: 'empresa', sortable: true },
                { key: 'situacao', width: null, label: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', width: null, label: 'excluir', sortable: false },
            ],
            assProdutoLoteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSPRODUTOLOTE'
            ),
            loteIntegracao: this.$store.state.user.tabelasERPWebServer.includes('LOTE'),
            permissaoTelaAssProdutoLote: null,
            permissaoTelaLote: null,
            assLotes: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            assLoteSelected: null,
            debouncedOnSearch: null,
            queryFilter: '.*',
            column: 'lote',
            order: 'desc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            isUpdate: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissaoTelaAssProdutoLote = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-lote'
        );

        this.permissaoTelaLote = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-lote');

        this.produtoService = new VenProdutoService(this.$http, this.$router);
        this.service = new AssProdutoLoteService(this.$http, this.$router);
        this.idproduto = this.$route.params.id;
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },

    methods: {
        carregarDados() {
            this.findAllByProduct();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.findAllByProduct();
        },
        findAllByProduct(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.service
                .findAllByIdProduto(
                    this.idproduto,
                    this.situacaoSelected.id,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapAssProdutoLote)
                .then((value) => {
                    this.assLotes = value;
                    this.isEmpty = this.assLotes.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar lote.', e);
                    this.msgs.push(new Message('error', 'msg-erro-un-medida', true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        mapAssProdutoLote(item) {
            this.pagination.totalRows = item.totalElements;

            return item.content.map((r) => {
                return {
                    idassprodutolote: r.idassprodutolote,
                    idempresa: r.idempresa,
                    idproduto: r.idproduto,
                    descricaolote: r.lote.descricao,
                    descricaoempresa: r.empresa.nome,
                    datavalidade: r.datavalidade,
                    datadescricao: r.datadescricao,
                    idlote: r.lote.idlote,
                    qtde: r.qtde,
                    situacao: r.situacao,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricaolote'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 0 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('lote') }
                );
            let tempAssProdutoLote = {
                idassprodutolote: this.delete.idassprodutolote,
                situacao: this.delete.situacao == 0 ? 1 : 0,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(tempAssProdutoLote)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-n'
                                : 'msg-sucesso-ao-desativar-n', 
                            { n: this.$t('lote') }
                        );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.findAllByProduct(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.findAllByProduct(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.findAllByProduct(this.pagination.currentPage);
        },
        selectedLoteEdit(selected) {
            this.isUpdate = true;
            this.assLoteSelected = selected;
            this.showModalAssociacao = true;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.isUpdate = false;
            this.showModalCadastroLote = false;
            this.findAllByProduct();
        },
        showModalLote() {
            this.showModalAssociacao = !this.showModalAssociacao;
            this.assLoteSelected = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-lote {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
